<template>
    <div>
        <!-- <div>{{orderId}}</div> -->
        <div v-html = "payGateWay"></div>
    </div>
</template>

<script>
export default {
    name: 'paygateway',

    data() {
        return {
            timer:null,
            payGateWay:'',
            orderId:'',
            type:'',
        };
    },

    mounted() {
        let form = this.$route.query.htmlData;
        this.orderId=this.$route.query.orderId;
        this.type=this.$route.query.type;
        this.payGateWay = form
        this.$nextTick(()=> {
            // this.orderFn()
            // document.forms[0].setAttribute('target', '_self');
            document.forms[0].submit();
        })
    },

    methods: {
        orderFn(){
            var self = this;
            if(this.orderId != undefined){
                //启用定时器
                clearInterval(this.timer);
                this.timer = setInterval(function(){
                    self.ifPaySuccess(this.orderId);
                },5000);
            }	
        },
        //是否支付成功
        ifPaySuccess(orderId){
            this.httpGet("web/unionPay/aliget", {
                orderId: orderId,
            }).then(res => {
                if(res.result.type == "1"){
                    clearInterval(this.timer);
                    console.log(res, "支付成功");
                    this.open(orderId);
                }
            });
        },
        //提示
        open(orderId) {
            this.$message.success('支付成功')
            var type=this.type
            this.$router.push({ path: "/paymentSuccess",query:{id:orderId,type:type}});
        },
    },
};
</script>

<style lang="scss" scoped>

</style>